<template>
    <div class="form-group row mt-0 mb-3 p-0">
        <label class="col-md-1 col-form-label text-right edit-in-place-label">{{custom.label}}</label>
        <div class="col-md-11">
            <edit-in-place  :type="custom.type"
                            :is-master="isMaster"
                            :null-select="nullSelect"
                            :master-value="masterValue"
                            :use-multi-select-role-type="useMultiSelectRoleType"
                            :property-value="custom.value"
                            :options="custom.options"
                            :read-only="custom.readOnly"
                            :show-save-and-sync="true">
                <api-handler
                    :attribute-id="common.id"
                    :version-id="common.selectedVersion"
                    :version-key="custom.versionKey"
                    :property-key="custom.key"
                    v-on="$listeners"
                    @success="$emit('changed')"
                    >
                </api-handler>
            </edit-in-place>
        </div>
        <div class="mt-1 text-xs max-w-para text-muted offset-md-1 col-md-11" v-if="description">
            {{ description }}
        </div>
    </div>
</template>

<script>

import EditInPlace from '../edit-in-place/edit-in-place.vue';
import AttributesConfigApiHandler from './attributes-config-api-handler.vue';

export default {
    name: 'attribute-element',
    components: {
        'edit-in-place': EditInPlace,
        'api-handler': AttributesConfigApiHandler,
    },
    props: {
        custom: Object,
        common: Object,
        description: {
            type: String,
            required: false
        }
    },
    computed: {
        nullSelect() {
            if (this.custom.hasOwnProperty('nullSelect')) {
                return this.custom.nullSelect;
            }
            return true;
        },
        useMultiSelectRoleType() {
            if (this.custom.type === "multi-select") {
                if (this.custom.hasOwnProperty('useMultiSelectRoleType')) {
                    return this.custom.useMultiSelectRoleType;
                }
            }
            return false;
        },
        masterValue() {
            if (this.custom.hasOwnProperty('masterValue')) {
                return this.custom.masterValue;
            }
            return null;
        },
        isMaster() {
            return (parseInt(this.common.selectedVersion, 10) === 0);
        },
        isNotMaster() {
            return !this.isMaster;
        }
    }
}
</script>

<style>
.edit-in-place-label {
    line-height: 1em;
}

</style>